export const NEW_FUNNEL_FORM = "configNewFunnelForm";
export const LOSS_REASON_FORM = "configLossReason";